<template>
  <div class="poll-results panel-settings">
  </div>
</template>

<script>
export default {
};
</script>
